module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



//////////////////
// WEBPACK FOOTER
// ./~/ripemd160/~/readable-stream/lib/internal/streams/from-browser.js
// module id = 664
// module chunks = 42